<template>
    <div>
        <zm-row>
            <zm-button size="small" @click="fetchData()" type="primary" class="btn-in-line" plain>show all trigger tasks</zm-button>
        </zm-row>
        <div class="table-container">
            <zm-table :data="list" v-loading="loading">
                <zm-table-column prop="taskId" label="taskId" align="center" :show-overflow-tooltip="true">
                </zm-table-column>
                <zm-table-column prop="retryTimes" label="retryTimes" align="center" :show-overflow-tooltip="true">
                </zm-table-column>
                <zm-table-column prop="status" label="status" align="center">
                </zm-table-column>
                <zm-table-column prop="modifiedTime" label="modifiedTime" align="center" :formatter="setTime" :show-overflow-tooltip="true">
                </zm-table-column>
                <zm-table-column width="80px" align="center">
                    <template slot-scope="scope">
                        <zm-button size="small" class="btn-contain" v-if="scope.row.reports" type="icon" title="show reports" icon="zm-icon-email" @click="showReports(scope.row.reports)"></zm-button>
                    </template>
                </zm-table-column>
            </zm-table>
            <div style="text-align: center" class="pagination-wrap">
                <zm-pagination @current-change="fetchData"
                    @size-change="handleSizeChange"
                    :current-page.sync="pageable.page" :page-size="pageable.size"
                    :page-sizes="[10, 20, 50, 100, 500, 1000]"
                    layout="sizes, total, prev, pager, next, jumper"
                    :total="pageable.total">
                </zm-pagination>
            </div>
        </div>
        <zm-dialog :visible.sync="reportsDialog" title="Reports" show-close>
            <p v-for="(item, index) in reports" :key="index">{{ item }}</p>
        </zm-dialog>
    </div>
</template>
<script>
import { listBatchTriggerTasks } from '../../api/trigger'
export default {
    name: 'task',
    data () {
        return {
            triggerId: '',
            list: [],
            loading: false,
            reports: [],
            reportsDialog: false,
            pageable: {
                page: 1,
                size: 10,
                total: 0
            }
        }
    },
    created () {
        if (localStorage.params && localStorage.params !== 'undefined' && localStorage.path === this.$route.path) {
            this.pageable.page = JSON.parse(localStorage.params).page
            this.pageable.size = JSON.parse(localStorage.params).size
        }
        localStorage.params = ''
        localStorage.path = this.$route.path
        this.triggerId = this.$route.params.triggerId
        this.fetchData()
    },
    watch: {
        'pageable.page' () {
            this.setURL()
        },
        'pageable.size' () {
            this.setURL()
        }
    },
    methods: {
        setURL () {
            const { page, size } = this.pageable
            const data = { path: this.$route.path, page, size }
            localStorage.params = JSON.stringify(data)
        },
        fetchData () {
            this.loading = true
            listBatchTriggerTasks(this.triggerId, this.pageable.size, this.pageable.page - 1).then(response => {
                const { content, pageable: { page, size }, total } = response
                this.list = content
                this.pageable.total = total
                this.pageable.page = page + 1
                this.pageable.size = size
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        },
        handleSizeChange (val) {
            this.pageable.size = val
            this.fetchData()
        },
        setTime (row, column, cellValue, index) {
            let time = row[column.property]
            return new Date(parseInt(time)).toLocaleString()
        },
        showReports (reports) {
            this.reports = reports
            this.reportsDialog = true
        }
    }
}
</script>
<style scoped>
.btn-in-line{
    margin: 10px
}
</style>
